export default __webpack_public_path__ + "4639a9854b39c540aea3ed141ee4bbe7.svg";